import { render, staticRenderFns } from "./ToolbarButton.vue?vue&type=template&id=12e32f7d&scoped=true"
import script from "./ToolbarButton.vue?vue&type=script&lang=ts"
export * from "./ToolbarButton.vue?vue&type=script&lang=ts"
import style0 from "./ToolbarButton.vue?vue&type=style&index=0&id=12e32f7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e32f7d",
  null
  
)

export default component.exports